export const getLocalizedDayNames = (locale: string): string[] => {
    const days: string[] = [];
    // Start with Monday (1) through Sunday (7)
    for (let i = 1; i <= 7; i++) {
        const date = new Date(2024, 0, i); // Using a date where 1st is a Monday
        days.push(new Intl.DateTimeFormat(locale, { weekday: 'long' }).format(date));
    }
    return days;
};

interface TimeFrame {
    startOfTimeFrame: Date;
    endOfTimeFrame: Date;
}

export const getMonthTimeframe = (month: number, year: number): TimeFrame => {
    const firstDayOfMonth = new Date(year, month, 1);
    const lastDayOfMonth = new Date(year, month + 1, 0);

    // Adjust the start of the range to the nearest Monday before or on the first day of the month
    const startDayOffset = firstDayOfMonth.getDay() === 0 ? -6 : -(firstDayOfMonth.getDay() - 1);
    const startOfTimeFrame = new Date(firstDayOfMonth);
    startOfTimeFrame.setDate(firstDayOfMonth.getDate() + startDayOffset);

    // Adjust the end of the range to the nearest Sunday after or on the last day of the month
    const endDayOffset = lastDayOfMonth.getDay() === 0 ? 0 : 7 - lastDayOfMonth.getDay();
    const endOfTimeFrame = new Date(lastDayOfMonth);
    endOfTimeFrame.setDate(lastDayOfMonth.getDate() + endDayOffset);

    return { startOfTimeFrame, endOfTimeFrame };
};

export const getWeeksInMonth = (month: number, year: number): Date[][] => {
    const weeks: Date[][] = [];
    const { startOfTimeFrame, endOfTimeFrame } = getMonthTimeframe(month - 1, year);
    const currentDate = new Date(startOfTimeFrame);

    while (currentDate <= endOfTimeFrame) {
        const week: Date[] = [];
        for (let i = 0; i < 7; i++) {
            week.push(new Date(currentDate));
            currentDate.setDate(currentDate.getDate() + 1);
        }
        weeks.push(week);
    }

    return weeks;
};

export const formatDate = (dateString: string): string => {
    const date = new Date(dateString);

    // Use Intl.DateTimeFormat for localized date formatting
    return new Intl.DateTimeFormat('nl-NL', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
    }).format(date);
};

// Optional: Add time formatting if needed
export const formatDateTime = (dateString: string): string => {
    const date = new Date(dateString);

    return new Intl.DateTimeFormat('nl-NL', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    }).format(date);
};
